export default {"src":"/_next/static/media/siding-replacement.e7ca48dc.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};